import Box from 'components/Box';
import Text from 'components/Text';
import React from 'react';
import styled from 'styled-components';
import { IStaffUI } from 'types/staff';
import iconEdit from '../icon-edit.svg';
import { Avatar } from 'antd';
import { RefreshIcon } from 'components/Nav/icons';

type StaffSectionProps = {
  currentStaff?: IStaffUI;
  onEditStaff: () => void;
};

const StaffSection = ({ currentStaff, onEditStaff }: StaffSectionProps) => {
  return (
    <Box flex={1} display='flex' alignItems='center' gap='2'>
      <Avatar size={48} src={currentStaff?.avatar} >{currentStaff?.name?.[0] || ''}</Avatar>
      <Text style={{ fontSize: '18px', textTransform: 'uppercase' }} variant="H3" color="text_3">
        {currentStaff?.name}
      </Text>
      <button onClick={onEditStaff}>
        <RefreshIcon fill="#148CF1" />
      </button>
    </Box>
  );
};

const StaffContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  span {
    &.text-label {
      color: #1D2129;
      font-size: 16px;
    }
    &.text-value {
      color: #148CF1;
    }
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    text-transform: capitalize;
  }
  .btn-edit-custom {
    width: unset;
    gap: 8px;
    display: flex;
    align-items: center;
    .icon-edit {
      width: 28px;
      height: 28px;
    }
  }
`;

export default StaffSection;
